import React from 'react'

import i18n from 'i18n-literally'
import { useConnect } from 'redux-bundler-hook'

import ConfirmationDialog from '~/src/UI/Shared/ConfirmationDialog'
import T from '~/src/UI/Shared/Typography'

const Component = ({ open, onClose }) => (
  <ConfirmationDialog
    noCancel
    confirmText={i18n`I understand`}
    destructive={false}
    maxWidth="sm"
    open={open}
    title={i18n`Please connect to the internet.`}
    titleProps={{ variant: 'h3' }}
    onCancel={onClose}
    onClose={(_, reason) => {
      if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') onClose()
    }}
    onConfirm={onClose}
  >
    <T.H5.Lite color="textSecondary" component="p">
      {i18n`Harvested yields have not been saved to the cloud.`}
      {' '}
      {i18n`Leaving AROYA could result in the loss of harvest data.`}
      {' '}
      {i18n`The only way to ensure data is not lost is to reconnect to the internet.`}
    </T.H5.Lite>
  </ConfirmationDialog>
)

const Connected = () => {
  const {
    showUnsavedHarvestingLeaveDialog,
    doHideUnsavedHarvestingLeaveDialog
  } = useConnect('selectShowUnsavedHarvestingLeaveDialog', 'doHideUnsavedHarvestingLeaveDialog')
  return showUnsavedHarvestingLeaveDialog ? (
    <Component
      open={showUnsavedHarvestingLeaveDialog}
      onClose={doHideUnsavedHarvestingLeaveDialog}
    />
  ) : null
}

export default Connected
